import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import { GlobalModals } from '../../constants/AppConstants';
import ModalActions from '../../actions/ModalActions';
import config from "../../config";
import TrackingActions from "../../actions/TrackingActions";

function RegisterLink ({ onClick, className, isSmartcardDelivery }) {

    const externalRegistrationLink = config.get('externalRegistrationLink');

    const _handleClick = () => {
        if (externalRegistrationLink) {
            TrackingActions.externalLink({ name: 'register' });
            window.open(externalRegistrationLink);
        } else {
            ModalActions.open(GlobalModals.REGISTER, {
                forceSmartcardSignup: isSmartcardDelivery,
                disableSuccessDropdown: isSmartcardDelivery,
            });
            onClick();
        }
    };

    return (
        <button
            role={ externalRegistrationLink ? 'link' : 'button' }
            type="button"
            aria-label={ t('ariaLabel.openRegister') }
            className={ className }
            onClick={ _handleClick }
        >
            { t('account.register') }
        </button>
    );

}

RegisterLink.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    isSmartcardDelivery: PropTypes.bool,
};

RegisterLink.defaultProps = {
    className: 'btn btn-primary btn-lg btn-register',
    isSmartcardDelivery: false,
    onClick: _.noop
};

export default RegisterLink;



// WEBPACK FOOTER //
// ./src/components/nav/RegisterLink.js